import React from 'react';

import { Auth } from 'aws-amplify';
import { connect } from 'react-redux';
import { Col, Form, Label, Row } from 'reactstrap';
import { bindActionCreators } from 'redux';

import { setNavigateToMsg } from '../../actions/Notifications/ScreenReaderInit';
import { setPageTitle } from '../../actions/Page/PageAction';
import { getDefaultUsersList } from '../../actions/Users/UserAction';
import Api from '../../Api';
import Constants from '../../Constants';
import { hasAnyError, validateAny, validateEmail, validatePhoneNumber } from '../Common/Errors/Errors';
import Inputs from '../Common/Inputs/Inputs';
import MobileInput from '../Common/Inputs/MobileInput';
import FlashMessages from '../Common/Messages/FlashMessages';
import ChangePassword from '../Password/ChangePassword';
import { FormButtons, Loading } from '../Common';

const { layoutGridSize, formLabelSize, formLabelSizeSm } = Constants;

const api = new Api();

class Settings extends React.Component {
  state = {
    user: '',
    username: '',
    given_name: '',
    family_name: '',
    phone_number: '',
    msgType: '',
    msgShow: false,
    msg: '',
    formInputsValidation: {},
    validation: true,
    userRole: '',
    isBusy: false,
    isFetching: false,
  };

  async componentDidMount() {
    this.props.setPageTitle('Edit Settings');
    this.props.setNavigateToMsg('Edit Settings');
    this.setState({
      isFetching: true,
    });

    try {
      const awsUser = await Auth.currentAuthenticatedUser();
      const ourUser = await api.getData(Constants.apiUrls.currentUser);
      this.setState({
        user: awsUser,
        username: ourUser.email,
        given_name: ourUser.given_name || '',
        family_name: ourUser.family_name || '',
        phone_number: ourUser.phone_number.replace('+', '') || '',
        userRole: awsUser.signInUserSession.idToken.payload['custom:userRole'],
      });
    } catch (err) {
      console.error(err);
    }
    this.setState({
      isFetching: false,
    });
  }

  componentWillUnmount() {
    this.props.setPageTitle();
  }

  handleInputChange = (inputFields, value) => {
    this.setState({
      [inputFields.name]: value,
    });
  };

  submitForm = () => {
    const { username, given_name, family_name, phone_number } = this.state;
    const formInputsValidation = {
      username: validateEmail(username),
      given_name: validateAny(given_name),
      family_name: validateAny(family_name),
      phone_number: validatePhoneNumber(phone_number),
    };
    this.setState({ formInputsValidation });
    const hasErrors = hasAnyError(formInputsValidation);
    this.hideFlashMessage();
    !hasErrors && !this.state.isBusy ? this.saveSettings() : void 0;
  };

  saveSettings = async () => {
    const { user, given_name, family_name, phone_number } = this.state;

    this.setState({
      isBusy: true,
    });

    try {
      const body = {
        given_name: given_name,
        family_name: family_name,
        phone_number: `+${phone_number}`,
      };
      await Auth.updateUserAttributes(user, body);
    } catch (err) {
      console.error(err);
      this.setState({
        msgType: 'error',
        msg: err.message || err,
        msgShow: true,
      });
    }

    try {
      await api.putData(Constants.apiUrls.currentUser, {
        body: {
          givenName: given_name,
          familyName: family_name,
          phoneNumber: `+${phone_number}`,
        },
      });
      this.setState({
        msgType: 'success',
        msg: 'User details saved successfully!',
        msgShow: true,
      });
    } catch (err) {
      console.error(err);
      this.setState({
        msgType: 'error',
        msg: err.response.data.error,
        msgShow: true,
      });
    }

    this.setState({
      isBusy: false,
    });
  };

  hideFlashMessage = () => {
    this.setState({ msgShow: false });
  };

  // canManageUsers = () => {
  //   const { userRole } = this.props.loggedUserDetails;
  //   const hasAccessRoles = ['ADMINISTRATOR_USER', 'SUPER_USER', 'ASSOCIATION_USER', 'INSTITUTION_USER'];
  //   return hasAccessRoles.includes(userRole);
  // };

  render() {
    const { msgShow, msg, msgType } = this.state;
    const impersonate = this.props.userPersonated;

    const controlSize = layoutGridSize - formLabelSize;
    const controlSizeSm = layoutGridSize - formLabelSizeSm;

    return (
      <div tabIndex={-1} className="component-settings mobile_margin signUp fontSm-15 init-focus__hidden">
        <FlashMessages
          close={this.hideFlashMessage}
          open={msgShow}
          type={msgType}
          msg={msg}
          classNames={'fl-settings'}
          scope="UserSettings"
        />
        <div className="pTop-30">
          <Form className="signUp-form settings-form margin-center">
            <h1 className="form-title-center" id="app_page_title">
              Edit Settings
            </h1>
            <h2 className="heading-h6-20">Account Information</h2>
            <Loading show={this.state.isFetching} backdrop classNames={['loading-settings']} />
            <Inputs
              onInputChange={this.handleInputChange}
              errorMessages={this.state.formInputsValidation.username}
              required="required"
              title="Email"
              id="email"
              name="username"
              autoComplete="email"
              placeholder="username"
              disabled="disabled"
              value={this.state.username}
            />
            <Inputs
              onInputChange={this.handleInputChange}
              errorMessages={this.state.formInputsValidation.given_name}
              required="required"
              title="First Name"
              id="firstName"
              autoComplete="given-name"
              name="given_name"
              placeholder="First Name"
              disabled={!!impersonate}
              value={this.state.given_name}
            />
            <Inputs
              onInputChange={this.handleInputChange}
              errorMessages={this.state.formInputsValidation.family_name}
              required="required"
              title="Last Name"
              id="surname"
              name="family_name"
              placeholder="Last Name"
              autoComplete="family-name"
              disabled={!!impersonate}
              value={this.state.family_name}
            />
            <MobileInput
              onInputChange={this.handleInputChange}
              errorMessages={this.state.formInputsValidation.phone_number}
              required="required"
              name="phone_number"
              title="Mobile Number"
              disabled={!!impersonate}
              value={this.state.phone_number}
            />
            <div className="pBottom-15">
              <Row className="v-middle-align">
                <Label className="ScalaSansOT" sm={formLabelSizeSm} md={formLabelSize}>
                  Password
                </Label>
                <Col className="input-left" sm={controlSizeSm} md={controlSize}>
                  <ChangePassword disabled={!!impersonate} />
                </Col>
              </Row>
            </div>
            <FormButtons
              submitDisabled={!!impersonate}
              submitLabel="Save"
              onSubmit={this.submitForm}
              isBusy={this.state.isBusy}
              wrapperClassNames={'mTop-40'}
              extraButtonProps={{
                id: 'button-save-settings',
              }}
            />
          </Form>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    usersList: state.Users.usersList,
    loggedUserDetails: state.AppSession.userDetails,
    userPersonated: state.Impersonate.impersonate.userPersonated,
  };
}
function matchDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      setNavigateToMsg,
      getDefaultUsersList,
      setPageTitle,
    },
    dispatch,
  );
}

export default connect(mapStateToProps, matchDispatchToProps)(Settings);
